import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/ios-icon-86_86.png'
import _imports_1 from '@/assets/img/箭头icon-60_60.png'
import _imports_2 from '@/assets/img/安卓icon-86_86.png'
import _imports_3 from '@/assets/img/Path.png'


const _hoisted_1 = { class: "home h5" }
const _hoisted_2 = { class: "latest-domain" }
const _hoisted_3 = { class: "domain banner" }
const _hoisted_4 = { class: "http-title" }
const _hoisted_5 = { class: "domain-list" }
const _hoisted_6 = { class: "click-copy h5" }
const _hoisted_7 = { class: "link-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "vpn" }
const _hoisted_10 = {
  href: "https://hongtaiyang.vip/",
  target: "_blank"
}
const _hoisted_11 = { class: "domain container" }
const _hoisted_12 = { class: "download-title" }
const _hoisted_13 = { class: "domain-list pc" }
const _hoisted_14 = {
  class: "download-link",
  href: "https://testflight.apple.com/join/WcffBUBg",
  target: "_blank"
}
const _hoisted_15 = {
  class: "download-link",
  href: "https://apps.apple.com/us/app/greenx/id6746765904",
  target: "_blank"
}
const _hoisted_16 = { class: "international-android" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  class: "download-link",
  href: "https://capp-build.oss-accelerate.aliyuncs.com/GreenX/GreenX_6.2.7_6020719.apk",
  target: "_blank"
}
const _hoisted_20 = { class: "international-android" }
const _hoisted_21 = { class: "warning" }
const _hoisted_22 = { class: "domain-list h5" }
const _hoisted_23 = {
  class: "download-link",
  href: "https://testflight.apple.com/join/WcffBUBg",
  target: "_blank"
}
const _hoisted_24 = { class: "download-text" }
const _hoisted_25 = { class: "download-title-h5" }
const _hoisted_26 = { class: "download-info" }
const _hoisted_27 = {
  class: "download-link",
  href: "https://apps.apple.com/us/app/greenx/id6746765904",
  target: "_blank"
}
const _hoisted_28 = { class: "download-text" }
const _hoisted_29 = { class: "download-title-h5" }
const _hoisted_30 = { class: "download-info" }
const _hoisted_31 = { class: "warning-store" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "download-text" }
const _hoisted_34 = { class: "download-title-h5" }
const _hoisted_35 = { class: "download-info" }
const _hoisted_36 = { class: "international-download-link" }
const _hoisted_37 = { class: "domain" }
const _hoisted_38 = { class: "domain-list pc" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "international-android" }
const _hoisted_41 = { class: "warning" }
const _hoisted_42 = { class: "international-android" }
const _hoisted_43 = {
  class: "google-auth",
  target: "_blank",
  href: "https://hongtaiyang.vip/files/%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E5%99%A8-GreenX%E8%B4%A6%E5%8F%B7%E5%A6%82%E4%BD%95%E8%AE%BE%E7%BD%AE%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E7%A0%81.pdf"
}
const _hoisted_44 = { class: "microsoft" }
const _hoisted_45 = { class: "domain-list h5" }
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "download-text" }
const _hoisted_48 = { class: "download-title-h5" }
const _hoisted_49 = { class: "download-info" }
const _hoisted_50 = { class: "international-android" }
const _hoisted_51 = { class: "warning" }
const _hoisted_52 = { class: "international-android" }
const _hoisted_53 = {
  class: "google-auth",
  target: "_blank",
  href: "https://hongtaiyang.vip/files/%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E5%99%A8--GreenX%E8%B4%A6%E5%8F%B7%E5%A6%82%E4%BD%95%E8%AE%BE%E7%BD%AE%E8%B0%B7%E6%AD%8C%E9%AA%8C%E8%AF%81%E7%A0%81.pdf"
}
const _hoisted_54 = { class: "microsoft" }

import { reactive, ref } from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const doMainList = reactive([
    'www.greeng.vip',
    'www.green-x.tv',
    // 'www.green-x.icu'
])

const android = ref<string>('https://capp-build.oss-cn-hangzhou.aliyuncs.com/GreenX/GreenX_Release_6.6.9_6030049.apk');
const androidQrCode = ref<string>('');
const isCopySuccess = ref<boolean>(false);
const isCopyIndex = ref<number>(0);
// const googleAuthPath = ref<string>('https://hongtaiyang.vip/files/Authenticator.apk') //暂时隐藏此版本
const googleAuthPath = ref<string>('https://hongtaiyang.vip/files/谷歌身份验证器.apk')

// 复制文本
const copy = (str: string, index: number) => {
    isCopyIndex.value = index;
    const textarea = document.createElement('textarea');
    textarea.value = str;
    document.body.appendChild(textarea);
    textarea.select();  // 选择文本
    try {
        // 执行复制命令
        document.execCommand('copy');
        isCopySuccess.value = true;
        setTimeout(() => {
            isCopySuccess.value = false;
        }, 1500)
        console.log("复制成功")
    } catch (err) {
        console.error('复制失败：', err);
    }
    // 移除临时文本框
    document.body.removeChild(textarea);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "https://fangshilian.net/---" + _toDisplayString(_ctx.$t('请截图保存GreenX防失联网址')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('最新域名')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('点击复制最新域名到浏览器打开')), 1),
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doMainList, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "copyLink",
              key: index,
              onClick: ($event: any) => (copy(item, index))
            }, [
              _createTextVNode(_toDisplayString(item) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass([{'isCopySuccess': isCopySuccess.value && isCopyIndex.value === index}, "copy-success"])
              }, _toDisplayString(_ctx.$t('复制成功')), 3)
            ], 8, _hoisted_8))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t('【网络急救通道】请点击此处')) + " ", 1),
          _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('《查看优化网络方式》')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('此方式可以长期稳定访问APP和网页')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('下载APP客户端')), 1),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('IPhone手机Testflight下载')), 1),
            _createElementVNode("a", _hoisted_14, [
              _cache[0] || (_cache[0] = _createElementVNode("svg", {
                class: "bn-svg text-BasicBg h-6 w-6 flex-shrink-0",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M15.69 1.978c.133 1.149-.345 2.28-1.046 3.112-.73.819-1.9 1.445-3.037 1.364-.15-1.104.428-2.28 1.073-2.996.73-.815 1.997-1.438 3.01-1.48zm3.64 6.17c-.135.076-2.231 1.27-2.208 3.699.026 2.94 2.707 3.912 2.739 3.922-.015.069-.42 1.403-1.424 2.757-.84 1.193-1.72 2.359-3.116 2.38-.665.014-1.113-.168-1.58-.357-.488-.197-.996-.402-1.79-.402-.843 0-1.374.212-1.886.416-.442.177-.87.349-1.474.372-1.33.047-2.347-1.273-3.217-2.454-1.738-2.413-3.092-6.8-1.277-9.786.88-1.464 2.484-2.406 4.197-2.432.755-.014 1.48.262 2.114.504.485.186.918.35 1.273.35.312 0 .733-.158 1.224-.343.773-.291 1.72-.648 2.683-.552.659.018 2.536.247 3.745 1.924l-.003.002z",
                  fill: "currentColor"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('GreenX IOS版下载')), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('IPhone手机App Store下载')), 1),
            _createElementVNode("a", _hoisted_15, [
              _cache[1] || (_cache[1] = _createElementVNode("svg", {
                class: "bn-svg text-BasicBg h-6 w-6 flex-shrink-0",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M15.69 1.978c.133 1.149-.345 2.28-1.046 3.112-.73.819-1.9 1.445-3.037 1.364-.15-1.104.428-2.28 1.073-2.996.73-.815 1.997-1.438 3.01-1.48zm3.64 6.17c-.135.076-2.231 1.27-2.208 3.699.026 2.94 2.707 3.912 2.739 3.922-.015.069-.42 1.403-1.424 2.757-.84 1.193-1.72 2.359-3.116 2.38-.665.014-1.113-.168-1.58-.357-.488-.197-.996-.402-1.79-.402-.843 0-1.374.212-1.886.416-.442.177-.87.349-1.474.372-1.33.047-2.347-1.273-3.217-2.454-1.738-2.413-3.092-6.8-1.277-9.786.88-1.464 2.484-2.406 4.197-2.432.755-.014 1.48.262 2.114.504.485.186.918.35 1.273.35.312 0 .733-.158 1.224-.343.773-.291 1.72-.648 2.683-.552.659.018 2.536.247 3.745 1.924l-.003.002z",
                  fill: "currentColor"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('GreenX IOS版下载')), 1)
            ]),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('目前仅支持马来西亚地区苹果账户下载')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Android 下载')), 1),
            _createElementVNode("a", {
              class: "download-link",
              href: android.value,
              target: "_blank"
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                class: "bn-svg text-BasicBg h-6 w-6 flex-shrink-0",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M17.543 14.1a1 1 0 01-.997-.997 1 1 0 01.997-.997 1 1 0 01.997.997 1 1 0 01-.997.997zm-11.05 0a1 1 0 01-.996-.997 1 1 0 01.997-.997 1 1 0 01.997.997.993.993 0 01-.997.997zM17.9 8.082l1.994-3.458a.409.409 0 00-.155-.567.409.409 0 00-.567.156l-2.022 3.503a12.354 12.354 0 00-5.14-1.098c-1.857 0-3.594.394-5.14 1.098L4.848 4.213a.419.419 0 00-.568-.156.419.419 0 00-.155.567l1.994 3.458C2.689 9.948.348 13.423 0 17.52h24c-.32-4.107-2.67-7.583-6.1-9.44z",
                  fill: "currentColor"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('GreenX安卓版下载')) + " ", 1),
              _createElementVNode("img", {
                class: "android-qr-code",
                src: androidQrCode.value,
                alt: ""
              }, null, 8, _hoisted_18)
            ], 8, _hoisted_17)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Android 下载')), 1),
            _createElementVNode("a", _hoisted_19, [
              _cache[3] || (_cache[3] = _createElementVNode("svg", {
                class: "bn-svg text-BasicBg h-6 w-6 flex-shrink-0",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M17.543 14.1a1 1 0 01-.997-.997 1 1 0 01.997-.997 1 1 0 01.997.997 1 1 0 01-.997.997zm-11.05 0a1 1 0 01-.996-.997 1 1 0 01.997-.997 1 1 0 01.997.997.993.993 0 01-.997.997zM17.9 8.082l1.994-3.458a.409.409 0 00-.155-.567.409.409 0 00-.567.156l-2.022 3.503a12.354 12.354 0 00-5.14-1.098c-1.857 0-3.594.394-5.14 1.098L4.848 4.213a.419.419 0 00-.568-.156.419.419 0 00-.155.567l1.994 3.458C2.689 9.948.348 13.423 0 17.52h24c-.32-4.107-2.67-7.583-6.1-9.44z",
                  fill: "currentColor"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('GreenX国际版下载')), 1)
            ]),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('访问国际版需开启（网络加速器）才可正常使用')), 1),
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('重要提示！！若登录状态显示USDT充值显示（暂停），请重新连接网络加速器')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t('苹果手机')), 1),
            _createElementVNode("a", _hoisted_23, [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                class: "iphone-logo",
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('GreenX IOS版下载')), 1),
                _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('Testflight下载')), 1)
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                class: "arrow",
                src: _imports_1,
                alt: ""
              }, null, -1))
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t('苹果手机')), 1),
            _createElementVNode("a", _hoisted_27, [
              _cache[6] || (_cache[6] = _createElementVNode("img", {
                class: "iphone-logo",
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('GreenX IOS版下载')), 1),
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('APP Store下载')), 1)
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("img", {
                class: "arrow",
                src: _imports_1,
                alt: ""
              }, null, -1))
            ]),
            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('目前仅支持马来西亚地区苹果账户下载')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t('安卓手机')), 1),
            _createElementVNode("a", {
              class: "download-link",
              href: android.value,
              target: "_blank"
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("img", {
                class: "iphone-logo",
                src: _imports_2,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('GreenX安卓版下载')), 1),
                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('Android 下载')), 1)
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("img", {
                class: "arrow",
                src: _imports_1,
                alt: ""
              }, null, -1))
            ], 8, _hoisted_32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createVNode(_component_router_link, { to: {name: 'InternationalDownload'} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('了解GreenX国际版下载')) + " ", 1),
          _cache[10] || (_cache[10] = _createElementVNode("img", {
            class: "right-arrow",
            src: _imports_3,
            alt: ""
          }, null, -1))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('下载安卓版谷歌验证器')), 1),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('安卓版谷歌验证器 下载')), 1),
            _createElementVNode("a", {
              class: "download-link",
              href: googleAuthPath.value
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("svg", {
                class: "bn-svg text-BasicBg h-6 w-6 flex-shrink-0",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M17.543 14.1a1 1 0 01-.997-.997 1 1 0 01.997-.997 1 1 0 01.997.997 1 1 0 01-.997.997zm-11.05 0a1 1 0 01-.996-.997 1 1 0 01.997-.997 1 1 0 01.997.997.993.993 0 01-.997.997zM17.9 8.082l1.994-3.458a.409.409 0 00-.155-.567.409.409 0 00-.567.156l-2.022 3.503a12.354 12.354 0 00-5.14-1.098c-1.857 0-3.594.394-5.14 1.098L4.848 4.213a.419.419 0 00-.568-.156.419.419 0 00-.155.567l1.994 3.458C2.689 9.948.348 13.423 0 17.52h24c-.32-4.107-2.67-7.583-6.1-9.44z",
                  fill: "currentColor"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('谷歌验证器下载')), 1)
            ], 8, _hoisted_39),
            _createElementVNode("p", _hoisted_40, [
              _createTextVNode(_toDisplayString(_ctx.$t('谷歌验证器可用于开启（账户安全）中的（谷歌验证码）')), 1),
              _createElementVNode("i", _hoisted_41, _toDisplayString(_ctx.$t('重要提示！！设置谷歌验证码时，请注意保存谷歌密钥，防止丢失不易找回！')), 1)
            ]),
            _createElementVNode("p", _hoisted_42, [
              _createTextVNode(_toDisplayString(_ctx.$t('点击下载查看GreenX设置谷歌验证码指南')), 1),
              _createElementVNode("a", _hoisted_43, _toDisplayString(_ctx.$t('《谷歌验证器-GreenX账号如何设置谷歌验证码》')), 1),
              _cache[12] || (_cache[12] = _createTextVNode(" ----")),
              _createElementVNode("span", _hoisted_44, [
                _createVNode(_component_router_link, { to: {name: 'GoogleAuthenticator'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('了解微软Authenticator')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "download-link",
              href: googleAuthPath.value,
              target: "_blank"
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("img", {
                class: "iphone-logo",
                src: _imports_2,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('谷歌验证器下载')), 1),
                _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('安卓版谷歌验证器下载')), 1)
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                class: "arrow",
                src: _imports_1,
                alt: ""
              }, null, -1))
            ], 8, _hoisted_46)
          ])
        ]),
        _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t('谷歌验证器可用于开启（账户安全）中的（谷歌验证码）')), 1),
        _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('重要提示！！设置谷歌验证码时，请注意保存谷歌密钥，防止丢失不易找回！')), 1),
        _createElementVNode("p", _hoisted_52, [
          _createTextVNode(_toDisplayString(_ctx.$t('点击下载查看GreenX设置谷歌验证码指南')), 1),
          _createElementVNode("a", _hoisted_53, _toDisplayString(_ctx.$t('《谷歌验证器-GreenX账号如何设置谷歌验证码》')), 1),
          _cache[15] || (_cache[15] = _createTextVNode(" ----")),
          _createElementVNode("span", _hoisted_54, [
            _createVNode(_component_router_link, { to: {name: 'GoogleAuthenticator'} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('了解微软Authenticator')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})